<template>
  <div v-if="payload" class="course-card-container">
    <div class="course-card">
      <a :href="`/course-preview/${payload['slug']}`">
        <div v-intersection.once="intersection_handler" class="course-card__header" :style="computedBGImage">
          <span class="pill bg-blue-light">{{ isOnline }}</span>
          <span v-if="isClosingSoon" class="course-card__header-message closing-soon">Closing soon</span>
        </div>
        <div class="course-card__body">
          <h4 class="course-card__body-title">{{ payload['title'] }}</h4>
          <p class="course-card__body-text">{{ payload['summary'] }}</p>
        </div>
        <div :class="`course-card__footer ${footer_color}`">
          <div class="course-card__footer-group">
            <div class="course-card__footer-item" v-if="payload['prog-length']">
              <div class="icon-wrapper">
                <img class="icon" :src="`/images/icons/icon-clock-outline.svg?${$config.version}`" alt="Clock" width="20" height="19" loading="lazy">
              </div>
              <p class="course-card__footer-title">{{ payload['prog-length'] }}</p>
            </div>
          </div>

          <template v-if="payload['cost'] !== undefined">
            <div v-if="payload['cost'] && Number(payload['cost']) > 0" class="course-card__footer-price bg-blue-pale">
              <p class="text-blue-light">£{{ payload['cost'] }}</p>
            </div>
            <div v-if="!payload['cost'] || Number(payload['cost']) == 0" class="course-card__footer-price bg-green-pale">
              <p class="text-green">Free</p>
            </div>
          </template>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  import { differenceInDays } from 'date-fns';

	export default {
		props: {
			payload: {
				type: Object
			},
			footer_color: {
				type: String,
				default: 'bg-white'
			}
		},

		data() {
			return {
				visible: false
			}
		},

		methods:{
			intersection_handler(entries, observer, isIntersecting, ratio) {
				//console.log("handle",entries, observer, isIntersecting, ratio);
				if (isIntersecting) {
					this.visible = true;
				}

			}
		},
		computed: {
			computedBGImage() {
				if (this.visible) {
					return `background-image: url(${this.$filters.analyseImage(this.payload['cover-image'],'herosearchxs','herosearchsm')});`;
				}
				return '';
			},
      isOnline() {
        return this.payload['online'] ? 'Online' : this.payload['location-text'];
      },
      isClosingSoon() {
        if(this.payload['date-start']) {
          const days = differenceInDays(this.payload['date-start'], new Date());
          const result = days > 0 && days <= 21;
          return result;
        }
        return false;
      },
		}
	}
</script>
